import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.41893 7.16797C4.32498 7.18431 4.23175 7.22982 4.15363 7.30794L1.8115 9.65007C1.61817 9.8434 1.61817 10.1582 1.8115 10.3516L4.15363 12.6937C4.46613 13.0054 4.99998 12.7838 4.99998 12.3421V10.8333H15V12.3421C15 12.7838 15.5338 13.0054 15.8463 12.6937L18.1885 10.3516C18.3818 10.1582 18.3818 9.8434 18.1885 9.65007L15.8463 7.30794C15.5338 6.99544 15 7.21621 15 7.65788V9.16667H4.99998V7.65788C4.99998 7.32663 4.70076 7.11895 4.41893 7.16797Z",
		fill: "currentColor"
	})
});
export default SvgLine;
